import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from '../core.state';
import { Role } from '../entities/user/role.enum';
import { User } from '../entities/user/user.model';
import { selectLoggedUser } from './auth.selectors';

@Injectable({
    providedIn: 'root'
})
export class HomePageGuardService implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot) {
        return this.store.select(selectLoggedUser).pipe(
            map((user: User) => {
                switch (user.role) {
                    case Role.SuperAdmin:
                    case Role.MedicalConsultant:
                        this.router.navigate(['/admin/companies']);
                        break;
                    case Role.Employee:
                    case Role.Freelance:
                        this.router.navigate(['/users', user.id]);
                        break;
                    case Role.Company:
                        this.router.navigate(['/users']);
                        break;
                }
                return true;
            })
        );

    }
}
